import getShorterText from "Common/componentUtils/getShorterText";
export default {
    buildDocumentSavedSuccessfully: (name) => `Документ "${getShorterText(name, 40)}" успешно сохранен`,
    buildDocumentSavingFailed: (name) => `Не удалось сохранить документ "${getShorterText(name, 40)}"`
};
